module.exports = __webpack_public_path__ + "static/sport/bgi.ad32312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi.png
// module id = GEbI
// module chunks = 0